import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import LegacyButton from '../LegacyButton';
import Icon from '../Icon';

const StudyListFilter = ({
    filterValues,
    clearFilters,
    isFiltering,
    onUploadClick,
    getDataSourceConfigurationComponent,
}) => {
    const { t } = useTranslation('StudyList');
    return (
        <React.Fragment>

            {getDataSourceConfigurationComponent && getDataSourceConfigurationComponent()}
            {onUploadClick && (
                <div
                    className="text-primary-active flex cursor-pointer items-center gap-2 self-center text-lg font-semibold"
                    onClick={onUploadClick}
                >
                    <Icon name="icon-upload" />
                    <span>{t('Upload')}</span>
                </div>
            )}

            {/* TODO revisit the completely rounded style of button used for clearing the study list filter - for now use LegacyButton*/}
            {isFiltering && (
                <LegacyButton
                    rounded="full"
                    variant="outlined"
                    color="primaryActive"
                    border="primaryActive"
                    className="mx-8"
                    startIcon={<Icon name="cancel" />}
                    onClick={clearFilters}
                >
                    {t('ClearFilters')}
                </LegacyButton>
            )}
        </React.Fragment>
    );
};

StudyListFilter.propTypes = {
    filtersMeta: PropTypes.arrayOf(
        PropTypes.shape({
            /** Identifier used to map a field to it's value in `filterValues` */
            name: PropTypes.string.isRequired,
            /** Friendly label for filter field */
            displayName: PropTypes.string.isRequired,
            /** One of the supported filter field input types */
            inputType: PropTypes.oneOf(['Text', 'MultiSelect', 'DateRange', 'None']).isRequired,
            isSortable: PropTypes.bool.isRequired,
            /** Size of filter field in a 12-grid system */
            gridCol: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]).isRequired,
            /** Options for a "MultiSelect" inputType */
            option: PropTypes.arrayOf(
                PropTypes.shape({
                    value: PropTypes.string,
                    label: PropTypes.string,
                })
            ),
        })
    ).isRequired,
    filterValues: PropTypes.object.isRequired,
    numOfStudies: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    isFiltering: PropTypes.bool.isRequired,
    onUploadClick: PropTypes.func,
    getDataSourceConfigurationComponent: PropTypes.func,
};

export default StudyListFilter;
